
export default {
    setRoute({commit}, data) {
        commit('SET_ROUTE', data)
    },
    setDrawer({commit}, data) {
        commit('SET_DRAWER', data);
    },
    setLoading({commit}, data) {
        commit('SET_LOADING', data)
    },
    setPageLoading({commit}, data) {
        commit('SET_PAGE_LOADING', data)
    },
    setUser({commit}, data) {
        commit('SET_USER', data)
    },
    setAlert ({ commit }, data) {
        commit('SET_ALERT', data)
    },
    setAuthorization ({commit}, data) {
        commit('SET_AUTHORIZATION', data)
    },
    setColumns ({commit}, data) {
        commit('SET_COLUMNS', data)
    },
    setSetup ({commit}, data) {
        commit('SET_SETUP', data)
    },
    setCleaningDialogStatus ({commit}, data) {
        commit('SET_CLEANING_DIALOG_STATUS', data)
    }
}
